import type { VendorKey } from "~/components/landing/compareData";

// What the post pages read. The growth engine writes more keys than these; they pass
// through untyped until something reads them.
export type PostFrontmatter = {
  title: string;
  date: string;
  /** Read as `description ?? excerpt`: older posts carry `excerpt`. */
  description?: string;
  excerpt?: string;
  seoTitle?: string;
  lastUpdated?: string;
  labels?: string | string[];
  coverImage?: string;
  coverImageAlt?: string;
  /** Drawn on the typographic cover a post without `coverImage` gets. */
  coverStat?: { value: string; label: string };
  /** Posts sharing a cluster are each other's first related posts. */
  cluster?: string;
  compare?: VendorKey;
  /** Search keywords only; `labels` is the navigation. */
  tags?: string[];
  draft?: boolean;
};

/** The index's tabs, in order. A tab shows once a visible post carries its label. */
export const LABEL_TABS = ["For executives", "For builders", "Research", "Product updates"];

export const getPostSlugFromPath = (path: string) => path.replace(/^.*\//, "").replace(/\.mdx$/, "");

export const normalizeLabels = (labels?: string | string[]) => {
  if (!labels) return [];
  if (Array.isArray(labels)) {
    return labels.map((label) => label.trim()).filter(Boolean);
  }
  return labels
    .split(",")
    .map((label) => label.trim())
    .filter(Boolean);
};

export const labelToSlug = (label: string) =>
  label
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
